import useLocalization from "@/hooks/useLocalization";
import { unixTimeToComponents } from "@/tools/date/conversion";
import icons from "@/tools/icons";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";

type AdditionalInfoProps = { text: string; setAt?: string | null };
export default function AdditionalInfo({ text, setAt }: AdditionalInfoProps) {
  const { t } = useLocalization();

  return (
    <Card
      sx={{
        padding: "8px",
      }}
    >
      <Stack direction="row" gap={2}>
        <icons.Info fontSize="large" />
        <Stack>
          <Typography sx={{ whiteSpace: "pre-line" }}>{text}</Typography>
          {setAt && (
            <Stack direction="row" alignItems="center" gap={0.5}>
              <icons.Clock sx={{ fontSize: 12, color: "text.secondary" }} />
              <Typography variant="caption" color="text.secondary">
                {`${t("reservation:sentAt")}: ${t("date:date", { interpolation: unixTimeToComponents(setAt) })} ${format(new Date(setAt), "HH:mm")}`}
              </Typography>
            </Stack>
          )}
        </Stack>
      </Stack>
    </Card>
  );
}
